var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightbulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 443,
    viewBox: "0 0 250 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    width: 6,
    height: 55,
    fill: "#F6E4A1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 191.047,
    y: 8,
    width: 6,
    height: 55,
    transform: "rotate(22.5 191.047 8)",
    fill: "#F6E4A1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 10.2959,
    width: 6,
    height: 55,
    transform: "rotate(-22.5 55 10.2959)",
    fill: "#F6E4A1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 210.242,
    y: 83.1338,
    width: 6,
    height: 55,
    transform: "rotate(-135 210.242 83.1338)",
    fill: "#F6E4A1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 48.2422,
    width: 6,
    height: 55,
    transform: "rotate(-45 0 48.2422)",
    fill: "#F6E4A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5884 314.093L123.667 323.005L155.609 314.093V334.79L150.141 342.318V369.378L123.667 375L97.7681 369.378V341.977L92.5884 334.79V314.093Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5884 314.093L123.667 323.005V341.977L155.609 334.79L150.141 342.318L123.667 348.588V375L97.7681 369.378V341.977L92.5884 334.79V314.093Z",
    fill: "#D8D8D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7677 341.977L92.5879 334.791L123.666 341.977V348.589L97.7677 341.977Z",
    fill: "#9D9D9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 188.761L64.3875 94.474L82.2289 87H171.724L186.975 94.474L242.514 188.761L155.609 314.093L123.667 323.005L92.5884 314.093L10 188.761Z",
    fill: "#F6E4A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 188.761L64.3875 94.474L82.2289 87L52.3014 163.464L123.667 188.761L202.227 163.464L242.514 188.761L155.609 314.093L123.667 323.005L92.5884 314.093L10 188.761Z",
    fill: "#EBC644",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5884 314.093L10 188.761L52.3014 163.464L123.667 188.761V323.005L92.5884 314.093Z",
    fill: "#EBC644",
    fillOpacity: 0.7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126,
    cy: 418,
    rx: 100,
    ry: 25,
    fill: "url(#paint0_radial_839_14412)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_839_14412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126 418) rotate(90) scale(25 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/Lightbulb.6db51f26d023030b26f1f278b504c3ce.svg";
export { ForwardRef as ReactComponent };